import founders from "assets/images/team/1.jpg";
import web_dev from "assets/images/team/2.jpg"
import graphics_designer from "assets/images/team/3.jpg"
import dennis from "assets/images/team/4.jpg"
import { Slide } from "react-reveal";

const OurTeam = () => {
    const images = [
        {
            name: 'ATLAS',
            role: 'Founder',
            founder: true,
            img: founders,
        },
        {
            name: 'LOUIS',
            role: 'Graphic designer',
            img: graphics_designer,

        },
        {
            name: 'MASSIMO',
            role: 'Web developer',
            img: web_dev,
        },
        {
            name: 'DARIUS',
            role: 'Marketing specialist',
            img: dennis,
        },
    ];
    return (
        <section id="team">
            <div className="sec-heading-wrapper">
                <Slide bottom>
                    <h1 className="sec-heading">Team</h1>
                    {/* <p>
                    Meta masks has been developed by a team of entrepreneurs, marketing experts, artists who have extensive experience in digital art & blockchain space. The team is devoted to the community and this project by striving only for success and making a footprint in the Metaverse.
                    </p> */}
                </Slide>
            </div>
            <div className="team-wrapper row">
                {images.map((data, ind) => {
                    return (
                        <Slide key={ind} cascade top>
                            <div className="row column team-card">
                                <img loading="lazy" src={data.img} alt={data.name} />
                                <div className="member-card-body row column">
                                    <h2>{data.name}</h2>
                                    <p className="role-">{data.role}</p>
                                </div>
                            </div>
                        </Slide>
                    )
                })}
            </div>
        </section>
    )
}

export default OurTeam

